import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const SiteMap = () => {
  return (
    <div>
      <Navbar/>
      SiteMap
      <Footer/>
    </div>
  )
}

export default SiteMap
